import React, { useState } from "react";
import Popup from "reactjs-popup";
import "./AcceptRiskPopup.scss";
import { inactivePopupActivateList } from "../../../redux/constants/constants";

const AcceptRiskPopup = ({
  open,
  onClose,
  onAccept,
  loc,
}) => {
  const [tillDate, setTillDate] = useState("");
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({});

  const isResolveMode = inactivePopupActivateList.includes(loc);

  const validate = () => {
    const newErrors = {};

    if (!tillDate) {
      newErrors.tillDate = "Please select a date.";
    } else {
      const selected = new Date(tillDate).setHours(0, 0, 0, 0);
      const today = new Date().setHours(0, 0, 0, 0);

      if (selected < today) {
        newErrors.tillDate = "Date must be today or in the future.";
      }
    }

    if (!isResolveMode && !reason.trim()) {
      newErrors.reason = "Please provide a reason.";
    }

    return newErrors;
  };

  const handleAccept = () => {
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    onAccept(
      isResolveMode
        ? {
            tillDateEpoch: new Date(tillDate).getTime(),
          }
        : {
            tillDateEpoch: new Date(tillDate).getTime(),
            reason: reason.trim(),
          }
    );

    handleClose();
  };

  const handleClose = () => {
    setTillDate("");
    setReason("");
    setErrors({});
    onClose();
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <Popup
      open={open}
      onClose={handleClose}
      modal
      closeOnDocumentClick={false}
      contentStyle={{
        padding: 0,
        borderRadius: 10,
        border: "none",
        boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        width: "100%",
        maxWidth: 460,
      }}
      overlayStyle={{
        zIndex: 999999,
        background: "rgba(0,0,0,0.45)",
      }}
    >
      <div className="ar-popup">
        <div className="ar-popup__header">
          <h2 className="ar-popup__title">
            {isResolveMode ? "False Positive" : "Accept Risk"}
          </h2>
        </div>

        <p className="ar-popup__description">
          {isResolveMode
            ? "Please select the resolution date."
            : "You are accepting the risk for this alert. Please specify how long this acceptance is valid and provide a justification."}
        </p>

        <div className="ar-popup__body">
          <div className="ar-popup__field">
            <label className="ar-popup__label" htmlFor="ar-till-date">
              {isResolveMode ? "Resolution Date" : "Accept risk till"}
            </label>

            <input
              id="ar-till-date"
              type="date"
              className={`ar-popup__input${
                errors.tillDate ? " ar-popup__input--error" : ""
              }`}
              value={tillDate}
              min={today}
              onChange={(e) => {
                setTillDate(e.target.value);
                setErrors((prev) => ({
                  ...prev,
                  tillDate: undefined,
                }));
              }}
            />

            {errors.tillDate && (
              <span className="ar-popup__error">{errors.tillDate}</span>
            )}
          </div>

          {!isResolveMode && (
            <div className="ar-popup__field">
              <label className="ar-popup__label" htmlFor="ar-reason">
                Reason
              </label>

              <textarea
                id="ar-reason"
                className={`ar-popup__textarea${
                  errors.reason ? " ar-popup__textarea--error" : ""
                }`}
                placeholder="Describe why this risk is being accepted..."
                value={reason}
                rows={3}
                onChange={(e) => {
                  setReason(e.target.value);
                  setErrors((prev) => ({
                    ...prev,
                    reason: undefined,
                  }));
                }}
              />

              {errors.reason && (
                <span className="ar-popup__error">{errors.reason}</span>
              )}
            </div>
          )}
        </div>

        <div className="ar-popup__actions">
          <button
            className="ar-popup__btn ar-popup__btn--cancel"
            onClick={handleClose}
          >
            Cancel
          </button>

          <button
            className="ar-popup__btn ar-popup__btn--accept"
            onClick={handleAccept}
          >
            {isResolveMode ? "False Positive" : "Accept Risk"}
          </button>
        </div>
      </div>
    </Popup>
  );
};

export default AcceptRiskPopup;